import { Box, BoxProps } from "@chakra-ui/react";

interface SectionDividerProps extends BoxProps {
  showIf?: boolean;
}

export const SectionDivider = ({
  showIf = true,
  ...props
}: SectionDividerProps) => {
  if (!showIf) return null;

  return (
    <Box
      borderTop="1px solid"
      borderColor="brand.neutral.medium"
      mb="1.5rem"
      {...props}
    />
  );
};
